<template>
  <dialog-modal-fi
    ref="dialogModal"
    class="consent-dialog-fi"
    only-body-scrollable
    prevent-close-on-click-outside
    pulse-on-block
    hide-close-button
  >
    <template #header>
      <h2 class="consent-dialog-fi__headline">
        {{ fields?.consentDialogHeadline?.value }}
      </h2>
    </template>

    <template #body>
      <div class="consent-dialog-fi__content">
        <div
          v-if="fields?.consentDialogInfotext?.value"
          class="consent-dialog-fi__content__info"
        >
          {{ fields.consentDialogInfotext.value }}
        </div>

        <div
          v-if="
            fields?.consentDialogTermsAndConditionsTitle?.value &&
            fields.consentDialogTermsAndConditionsText?.value
          "
          class="consent-dialog-fi__content__item"
        >
          <h3 class="consent-dialog-fi__content__title">
            {{ fields.consentDialogTermsAndConditionsTitle.value }}
          </h3>

          <richtext-fi
            class="consent-dialog-fi__content__text"
            :html-content="fields.consentDialogTermsAndConditionsText"
          />

          <link-fi
            v-if="
              fields.consentDialogTermsAndConditionsLink?.value &&
              (fields.consentDialogTermsAndConditionsLink.value.url ||
                fields.consentDialogTermsAndConditionsLink.value.href)
            "
            class="consent-dialog-fi__content__link"
            :href="
              fields.consentDialogTermsAndConditionsLink.value.url ||
              fields.consentDialogTermsAndConditionsLink.value.href
            "
            :external="Boolean(fields.consentDialogTermsAndConditionsLink.value.url)"
            primary
            target="_blank"
          >
            {{ fields.consentDialogTermsAndConditionsLink.value.text }}
          </link-fi>
        </div>
        <div
          v-if="
            fields?.consentDialogTermsOfUseTitle?.value && fields.consentDialogTermsOfUseText?.value
          "
          class="consent-dialog-fi__content__item"
        >
          <h3 class="consent-dialog-fi__content__title">
            {{ fields.consentDialogTermsOfUseTitle.value }}
          </h3>

          <richtext-fi
            class="consent-dialog-fi__content__text"
            :html-content="fields.consentDialogTermsOfUseText"
          />

          <link-fi
            v-if="
              fields.consentDialogTermsOfUseLink?.value &&
              (fields.consentDialogTermsOfUseLink.value.url ||
                fields.consentDialogTermsOfUseLink.value.href)
            "
            class="consent-dialog-fi__content__link"
            :href="
              fields.consentDialogTermsOfUseLink.value.url ||
              fields.consentDialogTermsOfUseLink.value.href
            "
            :external="Boolean(fields.consentDialogTermsOfUseLink.value.url)"
            target="_blank"
            primary
          >
            {{ fields.consentDialogTermsOfUseLink.value.text }}
          </link-fi>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="consent-dialog-fi__actions">
        <button-fi
          :class="{
            'consent-dialog-fi__button button-fi__primary': true,
            'button-fi--large-from-sm': true,
          }"
          type="button"
          @click.prevent="confirm"
        >
          {{ fields?.consentDialogButton?.value }}
        </button-fi>
      </div>
    </template>

    <template #button>
      <icon-fi icon="close" />
    </template>
  </dialog-modal-fi>
</template>

<script setup lang="ts">
import { ButtonFi, DialogModalFi, IconFi, LinkFi, RichtextFi } from 'atoms';
import { useTemplateRef } from 'vue';

import type { MyAccountLoginFields } from '@/generated/fields';

defineOptions({ name: 'ConsentDialogFi' });

withDefaults(
  defineProps<{
    fields?: MyAccountLoginFields | null;
  }>(),
  {
    fields: null,
  },
);

const emit = defineEmits<{
  confirm: [];
}>();

const dialogModal = useTemplateRef('dialogModal');

const open = () => {
  dialogModal.value?.open();
};

const close = () => {
  dialogModal.value?.close();
};

const confirm = () => {
  emit('confirm');
};

defineExpose({ open, close });
</script>

<style src="./consent-dialog-fi" />
